import Http from "./http";

export const getAllGroupsAPI = (data) => {
  return Http.post("admin/group/getAllGroupsByBrandId",data);
};
